import _ from 'lodash';


/* @ngInject */
export default function MonitoringGridFactory(uiGridConstants) {

  const STRING = 'string';
  const NUMBER = 'number';
  const DATE = 'date';
  const BOOLEAN = 'boolean';

  const MEDIUM = "date:'medium'";

  const STATUS = 'event.data.status';
  const STATUS_HDD = `${STATUS}.hdd`;
  const STATUS_VIDEO = `${STATUS}.videos`;
  const EQUIPMENT_SETTINGS = 'equipment.settings';

  function toColObj(field, displayName, type, cellFilter, sort) {
    return {
      field,
      displayName,
      type,
      cellFilter,
      sort,
      visible: true,
      enableCellEdit: false
    };
  }

  const uiGridOptions = {
    digi: {
      columnDefs: [
        toColObj('name', 'Digi', STRING, null, { direction: uiGridConstants.DESC }),
        toColObj('ip', 'IP', STRING),
        toColObj('lastConnect', 'Last Connection', DATE, MEDIUM),
        toColObj('lastDisconnect', 'Last Disconnection', DATE, MEDIUM)
      ]
    },
    rcu: {
      columnDefs: [
        toColObj('name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('id', 'ID', STRING),
        toColObj('ip', 'IP', STRING),
        toColObj('port', 'Port', NUMBER)
      ]
    },
    camera: {
      columnDefs: [
        toColObj('name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('id', 'ID', STRING),
        toColObj('rcu', 'RCU ID', STRING),
        toColObj('settings.protocol', 'Protocol', STRING),
        toColObj('settings.externalIp', 'External Address', STRING),
        toColObj('settings.externalPort', 'External Port', NUMBER)
      ]
    },
    tank: {
      columnDefs: [
        toColObj('equipment.name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('equipment.id', 'ID', STRING),
        toColObj('equipment.rcu.id', 'RCU ID', STRING),
        toColObj('event.eventDate', 'Last Event', DATE, MEDIUM),
        toColObj('event.eventName', 'Event Name', STRING),
        toColObj('event.data.reason', 'Reason', STRING)
      ]
    },
    cameraEvent: {
      columnDefs: [
        toColObj('equipment.name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('equipment.id', 'ID', STRING),
        toColObj('equipment.rcu.id', 'RCU ID', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.protocol`, 'Protocol', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalIp`, 'External Address', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalPort`, 'External Port', NUMBER),
        toColObj('count', 'Count', NUMBER),
        toColObj('event.eventDate', 'Last Event Date', DATE, MEDIUM)
      ]
    },
    cameraStatus: {
      columnDefs: [
        toColObj('equipment.name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('equipment.id', 'ID', STRING),
        toColObj('equipment.rcu.id', 'RCU ID', STRING),
        toColObj('equipment.rcu.name', 'RCU Name', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.protocol`, 'Protocol', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalIp`, 'External Address', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalPort`, 'External Port', NUMBER),
        toColObj('event.eventDate', 'Last Event Date', DATE, MEDIUM),
        toColObj('event.data.settings.continuousVideo', 'Cont. Video', BOOLEAN),
        toColObj(`${STATUS}.hddMounted`, 'HDD Mounted', BOOLEAN),
        toColObj(`${STATUS}.lastRecording`, 'Last Recording', DATE, MEDIUM),
        toColObj(`${STATUS}.lastVideoEvent`, 'Last Video Event', DATE, MEDIUM),
        toColObj(`${STATUS}.lastOnline`, 'Last Online', DATE, MEDIUM),
        toColObj(`${STATUS}.lastOffline`, 'Last Offline', DATE, MEDIUM),
        toColObj(`${STATUS}.lastRestart`, 'Last Restart', DATE, MEDIUM),
        toColObj(`${STATUS}.lastReset`, 'Last Reset', DATE, MEDIUM),
        toColObj(`${STATUS}.uptimeSeconds`, 'Uptime in Seconds', STRING),
        toColObj('event.data.properties.firmware', 'Firmware', STRING),
        toColObj('event.data.properties.model', 'Model', STRING),
        toColObj('event.data.properties.serial', 'Serial Number', STRING)
      ]
    },
    liveRcu: {
      columnDefs: [
        toColObj('name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('id', 'ID', STRING),
        toColObj('ip', 'IP', STRING),
        toColObj('port', 'Port', NUMBER),
        toColObj('state', 'State', STRING),
        toColObj('lastConnect', 'Last Connection', DATE, MEDIUM),
        toColObj('lastDisconnect', 'Last Disconnection', DATE, MEDIUM)
      ]
    },
    videoStatsGrid: {
      columnDefs: [
        toColObj('equipment.name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('equipment.id', 'ID', STRING),
        toColObj('event.data.properties.model', 'Model', STRING),
        toColObj('equipment.rcu.id', 'RCU ID', STRING),
        toColObj('equipment.rcu.name', 'RCU Name', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.protocol`, 'Protocol', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalIp`, 'External Address', STRING),
        toColObj(`${EQUIPMENT_SETTINGS}.externalPort`, 'External Port', NUMBER),
        toColObj('event.eventDate', 'Last Event Date', DATE, MEDIUM),
        toColObj('event.data.settings.continuousVideo', 'Cont. Video', BOOLEAN),
        toColObj(`${STATUS}.hddMounted`, 'HDD Mounted', BOOLEAN),
        toColObj(`${STATUS}.lastRecording`, 'Last Recording', DATE, MEDIUM),
        toColObj(`${STATUS}.lastVideoEvent`, 'Last Video Event', DATE, MEDIUM),
        toColObj(`${STATUS_HDD}.type`, 'HDD format', STRING),
        toColObj(`${STATUS_HDD}.totalSize`, 'HDD Size', NUMBER, 'kilobytes'),
        toColObj(`${STATUS_HDD}.totalUsed`, 'HDD Used', NUMBER, 'kilobytes'),
        toColObj(`${STATUS_HDD}.totalFree`, 'HDD Free', NUMBER, 'kilobytes')
      ]
    },
    videoStatsGrid2: {
      columnDefs: [
        toColObj('equipment.name', 'Name', STRING, null, { direction: uiGridConstants.ASC }),
        toColObj('equipment.id', 'ID', STRING),
        toColObj('event.data.properties.model', 'Model', STRING),
        toColObj(`${STATUS_VIDEO}.number`, 'No.', NUMBER),
        toColObj(`${STATUS_VIDEO}.maxSize`, 'Largest', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.minSize`, 'Smallest', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.totalSize`, 'Total Size', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.averageSize`, 'Average Size', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.averageSizeDay`, 'Average Size per Day', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.averageSizeHour`, 'Average Size per Hour', NUMBER, 'bytes'),
        toColObj(`${STATUS_VIDEO}.oldest`, 'Oldest', DATE),
        toColObj(`${STATUS_VIDEO}.newest`, 'Newest', DATE),
        // toColObj(`${videos}.historyMs`, 'Name', NUMBER),
        toColObj(`${STATUS_VIDEO}.minutes`, 'Total Minutes', NUMBER),
        toColObj(`${STATUS_VIDEO}.historyMinutes`, 'History in Minutes', NUMBER),
        toColObj(`${STATUS_VIDEO}.missing`, 'Missing Minutes', NUMBER),
        toColObj(`${STATUS_VIDEO}.resolution`, 'Resolution', STRING),
        toColObj(`${STATUS_VIDEO}.compression`, 'Compression', NUMBER),
        // toColObj(`${videos}.mirror`, '', NUMBER),
        toColObj(`${STATUS_VIDEO}.fps`, 'FPS', NUMBER),
        // toColObj(`${videos}.audio`, 'Name', NUMBER),
        toColObj(`${STATUS_VIDEO}.videokeyframeinterval`, 'GOP', NUMBER),
        toColObj(`${STATUS_VIDEO}.h264profile`, 'H264', STRING)
        // toColObj('${videos}.videocodec', 'Name', NUMBER),
      ]
    }
  };
  return option => _.cloneDeep(uiGridOptions[option]);
}
